import { c as _c } from "react/compiler-runtime";
interface PolygonIconProps {
  className?: string;
}
export function PolygonIcon(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maskType: "luminance"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <mask id="mask0_292_6244" style={t1} maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="200"><path d="M0 0H200V200H0V0Z" fill="white" /></mask>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#clip0_292_6244)">{t2}<g mask="url(#mask0_292_6244)"><path d="M175.585 39.416L114.062 3.87754C109.661 1.33636 104.668 -0.00146484 99.5861 -0.00146484C94.504 -0.00146484 89.5114 1.33636 85.1101 3.87754L23.5859 39.415C19.1834 41.9566 15.5278 45.6126 12.9866 50.0153C10.4453 54.418 9.10811 59.4122 9.10938 64.4957V135.502C9.1084 140.585 10.4458 145.579 12.987 149.981C15.5282 154.384 19.1836 158.04 23.5859 160.581L85.1091 196.121C89.5106 198.661 94.5031 199.999 99.5851 199.999C104.667 199.999 109.66 198.661 114.061 196.121L175.584 160.581C179.986 158.039 183.642 154.383 186.183 149.981C188.724 145.579 190.061 140.585 190.061 135.502V64.4967C190.062 59.4134 188.724 54.4193 186.183 50.0167C183.642 45.6141 179.987 41.958 175.585 39.416ZM175.585 135.503C175.587 138.044 174.919 140.542 173.648 142.743C172.378 144.944 170.549 146.772 168.348 148.042L106.824 183.545C104.63 184.834 102.131 185.514 99.5861 185.514C97.0411 185.514 94.5423 184.834 92.3479 183.545L30.8246 148.042C28.6236 146.771 26.796 144.943 25.5255 142.742C24.2549 140.541 23.5864 138.044 23.5869 135.503V64.4967C23.5926 61.9514 24.2635 59.4518 25.5331 57.2457C26.8026 55.0395 28.6268 53.2036 30.8246 51.9198L92.3479 16.4179C94.5486 15.1473 97.045 14.4784 99.5861 14.4784C102.127 14.4784 104.624 15.1473 106.824 16.4179L168.348 51.9208C170.546 53.2039 172.37 55.0396 173.64 57.2456C174.91 59.4517 175.58 61.9514 175.585 64.4967V135.503Z" fill="#8247E5" /><path d="M155.681 92.3468L132.157 78.7735C130.503 77.8306 128.632 77.3347 126.728 77.3347C124.825 77.3347 122.954 77.8306 121.3 78.7735L72.4435 107.02L52.539 95.5114V72.5143L72.4445 61.0058L92.347 72.5143V84.8926L106.823 76.4766V70.415C106.824 68.5081 106.323 66.6347 105.37 64.983C104.417 63.3313 103.046 61.9596 101.394 61.0058L77.8715 47.5246C76.2175 46.5821 74.3467 46.0864 72.443 46.0864C70.5393 46.0864 68.6684 46.5821 67.0144 47.5246L43.4916 61.0957C41.8486 62.0588 40.4842 63.4326 39.5324 65.0822C38.5806 66.7317 38.074 68.6005 38.0625 70.5049V97.6473C38.0726 99.5544 38.5784 101.426 39.5302 103.079C40.482 104.732 41.8471 106.108 43.4916 107.074L67.0144 120.645C68.6715 121.579 70.5415 122.07 72.4435 122.07C74.3456 122.07 76.2155 121.579 77.8726 120.645L126.729 92.3447L146.634 103.871V126.835L126.729 138.343L106.825 126.835V114.313L92.348 122.673V128.952C92.3567 130.849 92.8626 132.712 93.8151 134.353C94.7677 135.994 96.1337 137.357 97.7771 138.306L121.3 151.914C122.947 152.876 124.821 153.382 126.729 153.38C128.638 153.392 130.514 152.885 132.157 151.914L155.681 138.343C157.33 137.391 158.699 136.022 159.652 134.374C160.605 132.725 161.107 130.856 161.11 128.952V101.809C161.121 99.8928 160.625 98.0075 159.671 96.3451C158.718 94.6827 157.341 93.3024 155.681 92.3447V92.3468Z" fill="#8247E5" /></g></g>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="clip0_292_6244"><rect width="200" height="200" fill="white" /></clipPath></defs>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className) {
    t5 = <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t3}{t4}</svg>;
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}